import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import cn from 'classnames';
import { CurlyBraces } from '../../../icons/content-edit/CurlyBraces';
import { useBiAction } from '../../BiTracking';
import styles from './TokenToolbarButton.module.scss';
const ICON_SIZE = 16;
export function TokenToolbarButton(props) {
    const { label, onClick, disabled, className, testId, bi, noBi: _noBi } = props;
    const logBiAction = useBiAction();
    const handleClick = useCallback((event)=>{
        event.stopPropagation();
        if (bi === null || bi === void 0 ? void 0 : bi.name) {
            logBiAction({
                entityType: 'button',
                entityName: bi.name,
                actionType: 'click',
                data: _object_spread_props(_object_spread({}, bi.data), {
                    test_id: testId !== null && testId !== void 0 ? testId : ''
                })
            });
        }
        onClick(event.currentTarget);
    }, [
        bi,
        logBiAction,
        onClick,
        testId
    ]);
    return /*#__PURE__*/ _jsxs("button", {
        type: "button",
        disabled: disabled,
        className: cn(styles.button, className),
        onMouseDown: (event)=>event.preventDefault(),
        onClick: handleClick,
        "aria-haspopup": "dialog",
        "data-testid": testId,
        children: [
            label,
            /*#__PURE__*/ _jsx(CurlyBraces, {
                size: ICON_SIZE
            })
        ]
    });
}
